import React from 'react';
import { Chip, Stack } from '@mui/material';

import { useNewCampaign } from '../../../contexts/NewCampaignContext';

const ColumnsChips = ({ columns }) => {
    const { handleInsertTemplatePlaceholder } = useNewCampaign();

    return (
        <Stack direction="row" spacing={1} style={{ marginTop: '1.5rem' }}>
            {columns.map((column, index) => (
                <Chip
                    key={index}
                    label={column.name}
                    onClick={() => handleInsertTemplatePlaceholder(column.name)}
                />
            ))}
        </Stack>
    );
};

export default ColumnsChips;
